module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "songlists-hot"
  }, [_c('h2', [_vm._v("热门歌单")]), _vm._v(" "), _c('div', {
    staticClass: "ul row"
  }, _vm._l((_vm.info), function(n, index) {
    return _c('div', {
      key: n.id,
      staticClass: "li",
      attrs: {
        "track-by": "$index"
      }
    }, [_c('div', {
      staticClass: "info"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (n.imgurl),
        expression: "n.imgurl"
      }]
    }), _vm._v(" "), _c('div', {
      staticClass: "playNum"
    }, [_c('i', {
      staticClass: "iconfont icon-ear"
    }), _vm._v(" " + _vm._s(n.playcount) + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "btn-play iconfont icon-play",
      on: {
        "click": function($event) {
          _vm.setImg(n.imgurl, n.songs)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v("\n                        " + _vm._s(n.username) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                        " + _vm._s(n.specialname) + "\n                    ")])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9920ea2c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xsonglist/xsonglist.vue
// module id = 274
// module chunks = 0